<template>
    <div>
      <div class="modal hide fade" id="modalGetOnHand" tabindex="-1" role="dialog" aria-labelledby="modalGetOnHand" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">On Hand Lists</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <div class="form-inline ml-auto">
                      <div class="button-group">
                        <select v-model="company_no" class="form-control">
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                          <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="mr-1">
                          Total rows: <b>{{ rowsTotal }}</b>
                        </span>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        <button type="button" class="btn btn-sm btn-hard-primary ml-1" @click="refreshList"><i class="fa fa-refresh"></i></button>
                      </div>
                      <div class="form-group mx-sm-3 mb-2">
                          <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                      </div>
                      <span class="mr-1">
                        page:
                        <select v-model="currentPage">
                          <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                        </select>
                        / {{ pageLength }}
                      </span>
                      <nav aria-label="Page navigation example" class="pull-right">
                          <ul class="pagination">
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                                  </a>
                              </li>
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                                  </a>
                              </li>
                          </ul>
                      </nav>
                    </div>
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                          <tr>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                              {{ t.name }}
                              <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="9" style="text-align: center;">
                              <i>Loading <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></i>
                            </td>
                          </tr>
                            <tr v-for="u in filterData" v-bind:key="u.id">
                              <td>
                                <span v-if="u.type === 'in'" class="badge badge-success">{{ u.type }}</span>
                                <span v-else-if="u.type === 'begin'" class="badge badge-info">{{ u.type }}</span>
                                <span v-else class="badge badge-danger">{{ u.type }}</span>
                              </td>
                              <td>{{ u.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>
                                <span @click="selectData(u.id)" style="cursor: pointer;" data-dismiss="modal">
                                  <b>{{ u.hand_no }}</b>
                                </span>
                              </td>
                              <td><b>{{ u.name }}</b></td>
                              <td>{{ u.in_count }}</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                  <!-- <pre>{{ filterData }}</pre> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import { getHeader, inventoryUrl } from '../../config'
import Axios from 'axios'

export default {
  name: 'InventoryOnHandModal',
  components: {
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      load: false,
      company_no: null,
      categoryProduct: '',
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      startDate: [date1, date2],
      title: [{
        name: 'Type',
        prop: 'type'
      }, {
        name: 'Date',
        prop: 'hand_date'
      }, {
        name: 'Hand No',
        prop: 'hand_no'
      }, {
        name: 'Name',
        prop: 'name'
      }, {
        name: 'In',
        prop: 'in_count'
      }],
      selectAll: false,
      selected: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      onHandProductList: state => state.inventories.onHandList,
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.onHandProductList.length
      } else {
        count = this.onHandProductList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.onHandProductList.length
      } else {
        count = this.onHandProductList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.currentPage = 1
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.onHandProductList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async selectData (id) {
      await Axios.get(inventoryUrl + '/on-hand/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$emit('selectOnHand', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    refreshList () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = {
        begin: begin,
        end: end,
        company: this.company_no,
        type: null
      }
      this.$store.dispatch('getInventoryOnHandList', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    selectInventory: function (id) {
      var product = this.onHandProductList.find(d => d.id === id)
      this.$emit('selectOH', product)
    },
    select () {
      this.selected = []
      // this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  }
}
</script>
